export const getMethodByService = ({ service, modifyApi, modifySmsApi, createApi, createSmsApi, initialValues }) => {
    const modifyMethod = service ? modifyApi : modifySmsApi;
    const createMethod = service ? createApi : createSmsApi;
    return initialValues.id ? modifyMethod : createMethod;
};

export const hasFormErrors = (error) => {
    return Object.keys(error).some((formKey) => {
        const formError = error[formKey];

        return Object.keys(formError).some((itemKey) => {
            if (Array.isArray(formError[itemKey])) {
                return formError[itemKey].length;
            }

            return !!formError[itemKey];
        });
    });
};
